"use client";

import { Button } from "@eg/ui";
import { locales, type Locale } from "@/lib/i18n/config";
import {
  useLocale,
  useSetLocale,
  useTranslations,
} from "@/lib/i18n/I18nProvider";

export function LanguageSwitcher() {
  const locale = useLocale();
  const setLocale = useSetLocale();
  const t = useTranslations();

  const labels: Record<Locale, string> = {
    de: t("locale.de"),
    en: t("locale.en"),
  };

  return (
    <div className="inline-flex items-center gap-1 rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
      <span className="sr-only">{t("locale.label")}</span>
      {locales.map((candidate) => (
        <Button
          key={candidate}
          type="button"
          variant={candidate === locale ? "default" : "ghost"}
          size="sm"
          className="h-8 px-2"
          onClick={() => setLocale(candidate)}
          aria-pressed={candidate === locale}
        >
          {labels[candidate]}
        </Button>
      ))}
    </div>
  );
}
